export const slimeIdle = new Image();
slimeIdle.src = "./assets/characterSprites/slime/SlimeSheet.png";
slimeIdle.width = 256 / 8
slimeIdle.height = 75 / 3
slimeIdle.yOffset = 117.5
slimeIdle.xOffset = 195
slimeIdle.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];